// Marketing budget ledger + the Spend band on the Pipeline Analytics
// Marketing tab. Budgets are monthly and per-company; the summary joins them
// onto whatever window the page filters describe.

export const GET_MARKETING_SPEND_SUMMARY = gql`
  query GetMarketingSpendSummary($filters: StatusLogFiltersInput) {
    marketingSpendSummary(filters: $filters) {
      current {
        totalBudget
        costPerLead
        costPerHire
        attributedLeads
        cohortHires
        budgetedSourceCount
        missingMonths
        prorated
      }
      previous {
        totalBudget
        costPerLead
        costPerHire
        attributedLeads
        cohortHires
        budgetedSourceCount
        missingMonths
        prorated
      }
      costMetricsSuppressed
    }
  }
`

export const GET_MARKETING_BUDGET = gql`
  query GetMarketingBudget($companyId: String!, $month: DateTime!) {
    marketingBudget(companyId: $companyId, month: $month) {
      marketingBudgetId
      month
      effectiveTotal
      lines {
        marketingBudgetLineId
        linkType
        linkName
        amount
      }
    }
  }
`

export const UPSERT_MARKETING_BUDGET = gql`
  mutation UpsertMarketingBudget(
    $companyId: String!
    $input: UpsertMarketingBudgetInput!
  ) {
    upsertMarketingBudget(companyId: $companyId, input: $input) {
      marketingBudgetId
      month
      effectiveTotal
      lines {
        marketingBudgetLineId
        linkType
        linkName
        amount
      }
    }
  }
`
